<template>
  <div>
    <clipboard-modal
      :show="modals.clipboard"
      @copy="copyEmailsToClipboard"
      @cancel="closeModalClipboard"
    >
      <div class="scrollable">
        {{ emailsToCopy }}
      </div>
    </clipboard-modal>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div
            class="col-md-12 top-button top-buttons-list"
            style="display: inline-flex"
          >
            <div v-if="isPowerUserOrAdministrator">
              <button
                :class="editButtonClassObject"
                type="submit"
                class="top-button btn btn-fill btn-wd"
                aria-label="Demande d'édition ou enregistrement"
                @click.prevent="editButtonClicked"
              >
                <a v-if="editingDisabled">Editer</a>
                <a v-else>Enregistrer</a>
              </button>
              <button
                v-show="!editingDisabled"
                type="warning"
                class="top-button btn btn-warning btn-fill btn-wd"
                aria-label="Annuler"
                @click.prevent="cancelButtonClicked"
              >
                Annuler
              </button>
              <button
                v-show="!editingDisabled && !newListCreation"
                type="danger"
                class="top-button btn btn-danger btn-fill btn-wd"
                aria-label="Effacer"
                @click.prevent="deleteButtonClicked"
              >
                Effacer
              </button>
            </div>
            <p class="list-error-message">{{ listErrorMessage }}</p>
            <button
              v-show="editingDisabled && !newListCreation"
              id="btn-export-emails"
              type="primary"
              class="top-button btn btn-primary btn-fill btn-wd"
              aria-label="Envoyer email aux proffesseurs"
              @click.prevent="exportEmailsToTxtButtonClicked"
            >
              Emails Prof des personnes
            </button>
            <div
              v-show="editingDisabled && !newListCreation"
              class="export-dropdown"
            >
              <drop-down>
                <p-button
                  slot="title"
                  slot-scope="{ isOpen }"
                  :aria-expanded="isOpen"
                  type="primary"
                  round
                  block
                  aria-label="Ouvrir liste d'export"
                  class="dropdown-toggle"
                >
                  Exporter
                </p-button>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="exportToCsvIEButtonClicked(true)"
                  >Windows (IE) CSV</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="exportToCsvOtherButtonClicked(true)"
                  >Windows (Autres) CSV</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="exportToCsvOtherButtonClicked(false)"
                  >Mac CSV</a
                >
              </drop-down>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h5 v-if="editingDisabled" class="title">{{ customList.name }}</h5>
            <form v-if="editingDisabled">
              <div class="row mb-3">
                <div class="col-md-6">
                  <label>Dernière mise à jour</label>
                  <p>
                    {{
                      this.customList.lastUpdateDate
                        | moment('DD.MM.YYYY - HH:mm:ss')
                    }}
                  </p>
                </div>
                <div class="col-md-6">
                  <label>Créateur de la liste</label>
                  <p>{{ userId }}</p>
                </div>
              </div>
            </form>
            <div v-else class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <h5 v-if="newListCreation" class="title">Nouvelle Liste</h5>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form>
                          <div class="row">
                            <div class="col-md-12">
                              <fg-input
                                v-validate="'required'"
                                :disabled="editingDisabled"
                                v-model="customList.name"
                                data-vv-scope="formListDetails"
                                name="Nom"
                                required
                                type="text"
                                label="Nom"
                              />
                              <span>{{
                                errors.first('formListDetails.Nom')
                              }}</span>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!newListCreation" class="card-body">
            <div class="row">
              <div class="col-md-12">
                <tabs value="Description" tab-content-classes="text-center">
                  <tab-pane key="institutions" title="Institutions">
                    <form>
                      <div
                        v-if="!editingDisabled"
                        class="d-flex flex-row align-items-center"
                      >
                        <institution-select
                          ref="institutionSelectElement"
                          v-model="selectedInstitutionId"
                          placeholder="Ajoutez une institution"
                        />
                        <button
                          :disabled="selectedInstitutionId === undefined"
                          type="button"
                          class="btn btn-icon btn-round btn-success ml-2"
                          aria-label="Ajouter une institution"
                          @click="addInstitution"
                        >
                          <i class="fa fa-plus" />
                        </button>
                      </div>
                    </form>
                    <div class="row text-left">
                      <el-table :data="institutionsAssociations">
                        <el-table-column label="Nom" min-width="50">
                          <div slot-scope="slotScope">
                            {{ slotScope.row.institution.name }}
                          </div>
                        </el-table-column>
                        <el-table-column label="Acronyme" min-width="20">
                          <div slot-scope="slotScope">
                            {{
                              slotScope.row.institution.acronym
                                ? slotScope.row.institution.acronym
                                : '-'
                            }}
                          </div>
                        </el-table-column>
                        <el-table-column
                          align="right"
                          label="Action"
                          min-width="20"
                        >
                          <div slot-scope="slotScope">
                            <button
                              v-if="!editingDisabled"
                              type="button"
                              class="btn btn-icon btn-round btn-danger"
                              aria-label="Enlever une institution"
                              @click="removeInstitution(slotScope.row)"
                            >
                              <i class="fa fa-minus" />
                            </button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </tab-pane>

                  <tab-pane key="commissions" title="Commissions">
                    <form>
                      <div
                        v-if="!editingDisabled"
                        class="d-flex flex-row align-items-center"
                      >
                        <committee-select
                          ref="committeeSelectElement"
                          v-model="selectedCommitteeId"
                          placeholder="Ajoutez une commission"
                        />
                        <button
                          :disabled="selectedCommitteeId === undefined"
                          type="button"
                          class="btn btn-icon btn-round btn-success ml-2"
                          aria-label="Ajouter une commission"
                          @click="addCommittee"
                        >
                          <i class="fa fa-plus" />
                        </button>
                      </div>
                    </form>
                    <div class="row text-left">
                      <el-table :data="committeesAssociations">
                        <el-table-column label="Commission" min-width="80">
                          <div slot-scope="slotScope">
                            {{ slotScope.row.committee.name }}
                          </div>
                        </el-table-column>
                        <el-table-column
                          align="right"
                          label="Action"
                          min-width="20"
                        >
                          <div slot-scope="slotScope">
                            <button
                              v-if="!editingDisabled"
                              type="button"
                              class="btn btn-icon btn-round btn-danger"
                              aria-label="Enlever une commission"
                              @click="removeCommittee(slotScope.row)"
                            >
                              <i class="fa fa-minus" />
                            </button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </tab-pane>

                  <tab-pane key="people" title="Personnes">
                    <form>
                      <div
                        v-if="!editingDisabled"
                        class="d-flex flex-row align-items-center"
                      >
                        <person-select
                          ref="personSelectElement"
                          v-model="selectedPersonId"
                          placeholder="Ajoutez une personne"
                          @input="personIdSelectedEvent"
                        />
                        <member-address-type-select
                          id="select-address-type"
                          v-model="newPersonAddressType"
                          :member-id.sync="newPersonId"
                          :disabled="!newPersonSelected"
                          title="Type d'adresse"
                        />
                        <p-switch
                          v-model="switches.includeOrExclude"
                          class="ml-2"
                          type="primary"
                          on-text="I"
                          off-text="E"
                        />
                        <button
                          :disabled="
                            selectedPersonId === undefined ||
                              newPersonAddressType === undefined
                          "
                          type="button"
                          class="btn btn-icon btn-round btn-success ml-2"
                          aria-label="Ajouter une personne"
                          @click="addPerson"
                        >
                          <i class="fa fa-plus" />
                        </button>
                      </div>
                    </form>
                    <div class="row text-left">
                      <el-table
                        :data="peopleAssociations"
                        class="col-md-12 mydatalist"
                      >
                        <el-table-column label="Nom" min-width="30">
                          <div slot-scope="slotScope">
                            {{
                              slotScope.row.person.lastName != null &&
                              slotScope.row.person.firstName != null
                                ? slotScope.row.person.lastName
                                : slotScope.row.person.institutionName
                            }}
                            {{ slotScope.row.person.firstName }}
                          </div>
                        </el-table-column>
                        <el-table-column label="Type d'adresse" min-width="20">
                          <div slot-scope="slotScope">
                            {{
                              slotScope.row.addressTypeId
                                ? slotScope.row.addressTypeId
                                : '-'
                            }}
                          </div>
                        </el-table-column>
                        <el-table-column label="Incluse/exclue" min-width="20">
                          <div slot-scope="slotScope">
                            {{ slotScope.row.isIncluded }}
                          </div>
                        </el-table-column>
                        <el-table-column label="Action" min-width="20">
                          <div slot-scope="slotScope">
                            <button
                              v-if="!editingDisabled"
                              type="button"
                              class="btn btn-icon btn-round btn-danger"
                              aria-label="Enlever la personne"
                              @click="removePerson(slotScope.row)"
                            >
                              <i class="fa fa-minus" />
                            </button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </tab-pane>

                  <tab-pane key="profiles" title="Thèmes">
                    <form>
                      <div
                        v-if="!editingDisabled"
                        class="d-flex flex-row align-items-center"
                      >
                        <profile-select
                          ref="profileSelectElement"
                          v-model="selectedProfileId"
                        />
                        <button
                          :disabled="selectedProfileId === undefined"
                          type="button"
                          class="btn btn-icon btn-round btn-success ml-2"
                          aria-label="Ajouter un profile"
                          @click="addProfile"
                        >
                          <i class="fa fa-plus" />
                        </button>
                      </div>
                    </form>
                    <div class="row text-left">
                      <el-table :data="profilesAssociations">
                        <el-table-column label="Catégorie" min-width="80">
                          <div slot-scope="slotScope">
                            {{ slotScope.row.profile.category }}
                          </div>
                        </el-table-column>
                        <el-table-column label="Thème" min-width="80">
                          <div slot-scope="slotScope">
                            {{ slotScope.row.profile.name }}
                          </div>
                        </el-table-column>
                        <el-table-column
                          align="right"
                          label="Action"
                          min-width="20"
                        >
                          <div slot-scope="slotScope">
                            <button
                              v-if="!editingDisabled"
                              type="button"
                              class="btn btn-icon btn-round btn-danger"
                              aria-label="Enlever un profile"
                              @click="removeProfile(slotScope.row)"
                            >
                              <i class="fa fa-minus" />
                            </button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </tab-pane>
                </tabs>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!newListCreation" class="card">
          <div class="card-header">
            <h5 class="title">{{ linkedPeople.length }} personnes</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <ol>
                  <li
                    v-for="person in linkedPeople"
                    :key="person.id"
                    class="small-list-element"
                  >
                    <b>{{
                      person.lastName != null && person.firstName != null
                        ? person.lastName
                        : person.institutionName
                    }}</b>
                    {{ person.firstName }}
                    <button
                      v-if="!editingDisabled"
                      type="button"
                      class="btn btn-icon btn-round btn-danger small-button"
                      aria-label="Exclure une personne"
                      @click="excludePerson(person)"
                    >
                      <i class="fa fa-minus" />
                    </button>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isPowerUser,
  isAdministrator,
  isPowerUserOrAdministrator,
} from '@/services/AuthService';
import { Tabs, TabPane } from 'src/components/UIComponents';
import InstitutionSelect from 'src/components/ApplicationViews/UIComponents/InstitutionSelect.vue';
import CommitteeSelect from 'src/components/ApplicationViews/UIComponents/CommitteeSelect.vue';
import PersonSelect from 'src/components/ApplicationViews/UIComponents/PersonSelect.vue';
import MemberAddressTypeSelect from 'src/components/ApplicationViews/UIComponents/MemberAddressTypeSelect.vue';
import ProfileSelect from 'src/components/ApplicationViews/UIComponents/ProfileSelect.vue';
import PSwitch from 'src/components/UIComponents/Switch.vue';
import swal from 'sweetalert2';
import { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';

import EventBus from 'src/event-bus';
import ClipboardModal from './ClipboardModal.vue';

export default {
  components: {
    InstitutionSelect,
    CommitteeSelect,
    PersonSelect,
    MemberAddressTypeSelect,
    ProfileSelect,
    ClipboardModal,
    PSwitch,
    Tabs,
    TabPane,
  },
  data() {
    return {
      modals: {
        clipboard: false,
      },
      selectedInstitutionId: null,
      selectedCommitteeId: null,
      selectedPersonId: null,
      selectedProfileId: null,
      newPersonSelected: false,
      newPersonId: 1,
      newPersonAddressType: null,
      editingDisabled: true,
      newListCreation: false,
      customListId: {},
      customList: {},
      userId: '',
      institutionsAssociations: [],
      committeesAssociations: [],
      peopleAssociations: [],
      profilesAssociations: [],
      peopleById: new Map(),
      switches: {
        includeOrExclude: true,
      },
      listErrorMessage: '',
      emailsToCopy: '',
    };
  },
  computed: {
    isPowerUser,
    isAdministrator,
    isPowerUserOrAdministrator,
    editButtonClassObject() {
      return {
        'btn-warning': this.editingDisabled,
        'btn-success': !this.editingDisabled,
      };
    },
    linkedPeople() {
      const people = Array.from(this.peopleById.values());
      people.sort((a, b) => {
        if (a.lastName > b.lastName) {
          return 1;
        }
        if (a.lastName < b.lastName) {
          return -1;
        }
        if (a.firstName > b.firstName) {
          return 1;
        }
        if (a.firstName < b.firstName) {
          return -1;
        }
        return 0;
      });
      return people;
    },
  },
  watch: {
    selectedCommittee(oldVal, newVal) {},
    newPersonSelected: {
      handler(newValue, oldValue) {},
      deep: true,
    },
    selectedPersonId: {
      handler(newValue, oldValue) {},
      deep: true,
    },
    newPersonId: {
      handler(newValue, oldValue) {
        this.newPersonAddressType = null;
      },
      deep: true,
    },
    $route: {
      handler(newValue, oldValue) {
        this.newListCreation = newValue.params.newListCreation;
        if (this.newListCreation) {
          this.editingDisabled = false;
        } else {
          this.customListId = newValue.params.id;
          this.fetch();
          this.getPeopleList();
        }
      },
      deep: true,
    },
  },
  created() {
    this.newListCreation = this.$route.params.newListCreation;
    if (this.newListCreation) {
      this.editingDisabled = false;
    } else {
      this.customListId = this.$route.params.id;
      this.fetch();
      this.getPeopleList();
    }
    EventBus.$on('search', this.searchCustomList);
  },
  beforeDestroy() {
    EventBus.$off('search', this.searchCustomList);
  },
  mounted() {
    // Set the field validator to french
    Validator.localize('fr', fr);
  },
  methods: {
    searchCustomList(searchText) {
      this.$router.push({
        name: 'CustomLists',
        params: { searchText },
      });
    },
    showSwal(type) {
      if (type === 'warning-message-and-confirmation') {
        swal({
          title: 'Êtes-vous sûr de vouloir supprimer cette liste?',
          text: "Il ne sera pas possible d'annuler cette suppression!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Oui, effacer',
          cancelButtonText: 'Non, conserver',
          buttonsStyling: false,
        }).then(() => {
          this.deleteRecordList();
        });
      } else if (type === 'basic-email-copy-success') {
        swal({
          title: 'Succès',
          text:
            'Les adresses emails professionelles ont été copiées dans le presse-papier',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success',
        });
      } else if (type === 'basic-email-copy-failure') {
        swal({
          title: 'Erreur',
          text: 'Impossible de copier dans le presse-papier',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'error',
        });
      }
    },
    personIdSelectedEvent(input, event) {
      this.newPersonSelected = true;
      this.newPersonId = input;
    },
    fetch() {
      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/customlistEntities/${this.customListId}?projection=noDetailsDTO`,
        )
        .then(response => {
          this.customList = response.data;
          this.userId = this.customList.userId;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });

      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToInstitutionEntities/search/byCustomListId?clistId=${this.customListId}&projection=clistInstitutionDTO`,
        )
        .then(response => {
          this.institutionsAssociations =
            response.data._embedded.associationCustomListToInstitutionEntities;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue lors de la récupération des institutions de cette liste, veuillez réessayer ou contacter le support.';
        });

      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToCommitteeEntities/search/byCustomListId?projection=committeesDTO&id=${this.customListId}`,
        )
        .then(response => {
          this.committeesAssociations =
            response.data._embedded.associationCustomListToCommitteeEntities;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });

      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToPersonEntities/search/byCustomListId?projection=peopleDTO&id=${this.customListId}`,
        )
        .then(response => {
          this.peopleAssociations =
            response.data._embedded.associationCustomListToPersonEntities;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });

      this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToProfileEntities/search/byCustomListId?projection=profilesDTO&id=${this.customListId}`,
        )
        .then(response => {
          this.profilesAssociations =
            response.data._embedded.associationCustomListToProfileEntities;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    getPeopleList() {
      const fetchPeopleViaInstitutions = this.$http.get(
        `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToInstitutionEntities/search/people?projection=noDetailsDTO&customListId=${this.customListId}`,
      );
      const fetchPeopleViaCommittees = this.$http.get(
        `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToCommitteeEntities/search/people?projection=noDetailsDTO&customListId=${this.customListId}`,
      );
      const fetchPeopleViaProfiles = this.$http.get(
        `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToProfileEntities/search/people?projection=noDetailsDTO&customListId=${this.customListId}`,
      );
      const fetchPeople = this.$http.get(
        `${process.env.VUE_APP_ANNUAIRE_API_URL}/associationCustomListToPersonEntities/search/byCustomListId?projection=peopleDTO&id=${this.customListId}`,
      );
      Promise.all([
        fetchPeopleViaInstitutions,
        fetchPeopleViaCommittees,
        fetchPeopleViaProfiles,
        fetchPeople,
      ]).then(responses => {
        const people = []
          .concat(responses[0].data._embedded.personEntities)
          .concat(responses[1].data._embedded.personEntities)
          .concat(responses[2].data._embedded.personEntities);
        this.peopleById = new Map();
        people.forEach(person => {
          this.peopleById.set(person.id, person);
        });
        const invidualsToAddOrRemove =
          responses[3].data._embedded.associationCustomListToPersonEntities;
        invidualsToAddOrRemove.forEach(individual => {
          if (individual.isIncluded === 'I') {
            this.peopleById.set(individual.person.id, individual.person);
          }
          if (individual.isIncluded === 'E') {
            this.peopleById.delete(individual.person.id);
          }
        });
      });
    },
    addInstitution() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
          {
            associationType: 'institution',
            operation: 'add',
            customListId: this.customList.id,
            associatedEntityId: this.selectedInstitutionId,
          },
        )
        .then(response => {
          this.listErrorMessage = '';
          this.fetch();
          this.getPeopleList();
          this.selectedInstitutionId = null;
          this.$nextTick(() => {
            this.$refs.institutionSelectElement.selectedRecord = '';
          });
        })
        .catch(error => {
          this.listErrorMessage =
            "Une erreur est survenue lors de l'association de l'institution à la liste, veuillez réessayer ou contacter le support.";
        });
    },
    removeInstitution(association) {
      swal({
        title:
          "Êtes-vous sûr de vouloir supprimer l'association entre cette liste et cette institution ?",
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.$http
          .post(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
            {
              associationType: 'institution',
              operation: 'remove',
              customListId: this.customList.id,
              associatedEntityId: association.institution.id,
            },
          )
          .then(response => {
            this.fetch();
            this.getPeopleList();
          })
          .catch(error => {
            this.listErrorMessage =
              "Une erreur est survenue lors de la suppression de l'association de l'institution à la liste, veuillez réessayer ou contacter le support.";
          });
      });
    },
    addCommittee() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
          {
            associationType: 'committee',
            operation: 'add',
            customListId: this.customList.id,
            associatedEntityId: this.selectedCommitteeId,
          },
        )
        .then(response => {
          this.listErrorMessage = '';
          this.fetch();
          this.getPeopleList();
          this.selectedCommitteeId = undefined;
          this.$nextTick(() => {
            this.$refs.committeeSelectElement.selectedRecord = '';
          });
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    removeCommittee(association) {
      swal({
        title:
          "Êtes-vous sûr de vouloir supprimer l'association entre cette liste et cette commission ?",
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.$http
          .post(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
            {
              associationType: 'committee',
              operation: 'remove',
              customListId: association.id.comtclistClistId,
              associatedEntityId: association.id.comtclistComtId,
            },
          )
          .then(response => {
            this.fetch();
            this.getPeopleList();
          })
          .catch(error => {
            this.listErrorMessage =
              'Une erreur est survenue, veuillez réessayer ou contacter le support.';
          });
      });
    },
    addProfile() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
          {
            associationType: 'profile',
            operation: 'add',
            customListId: this.customList.id,
            associatedEntityId: this.selectedProfileId,
          },
        )
        .then(response => {
          this.listErrorMessage = '';
          this.fetch();
          this.getPeopleList();
          this.selectedProfileId = undefined;
          this.$nextTick(() => {
            this.$refs.profileSelectElement.selectedRecord = '';
          });
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    removeProfile(association) {
      swal({
        title:
          "Êtes-vous sûr de vouloir supprimer l'association entre cette liste et ce thème ?",
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.$http
          .post(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
            {
              associationType: 'profile',
              operation: 'remove',
              customListId: association.id.profclistClistId,
              associatedEntityId: association.id.profclistProfileId,
            },
          )
          .then(response => {
            this.fetch();
            this.getPeopleList();
          })
          .catch(error => {
            this.listErrorMessage =
              'Une erreur est survenue, veuillez réessayer ou contacter le support.';
          });
      });
    },
    addPerson(e) {
      if (this.selectedPersonId && this.newPersonAddressType) {
        this.listErrorMessage = null;

        this.$http
          .post(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
            {
              associationType: 'person',
              operation: this.switches.includeOrExclude
                ? 'add-include'
                : 'add-exclude',
              customListId: this.customList.id,
              associatedEntityId: this.selectedPersonId,
              properties: {
                includeOrExclude: this.switches.includeOrExclude ? 'I' : 'E',
                addressType: this.newPersonAddressType,
              },
            },
          )
          .then(response => {
            this.newPersonSelected = false;
            this.newPersonId = 1;
            this.newPersonAddressType = undefined;
            this.fetch();
            this.getPeopleList();
            this.selectedPersonId = undefined;
            this.$refs.personSelectElement.selectedRecord = '';
          })
          .catch(error => {
            this.listErrorMessage =
              'Une erreur est survenue, veuillez réessayer ou contacter le support.';
          });
      } else {
        this.listErrorMessage =
          "Veuillez sélectionner une personne et un type d'adresse.";
      }
    },
    removePerson(association) {
      swal({
        title:
          "Êtes-vous sûr de vouloir supprimer l'association entre cette liste et cette personne ?",
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.$http
          .post(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
            {
              associationType: 'person',
              operation: 'remove',
              customListId: association.id.persclistClistId,
              associatedEntityId: association.id.persclistPersId,
            },
          )
          .then(response => {
            this.fetch();
            this.getPeopleList();
          })
          .catch(error => {
            this.listErrorMessage =
              'Une erreur est survenue, veuillez réessayer ou contacter le support.';
          });
      });
    },
    excludePerson(person) {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/associations/`,
          {
            associationType: 'person',
            operation: 'add-exclude',
            customListId: this.customList.id,
            associatedEntityId: person.id,
            properties: {
              includeOrExclude: 'E',
              addressType: null,
            },
          },
        )
        .then(response => {
          this.listErrorMessage = '';
          this.fetch();
          this.getPeopleList();
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    editButtonClicked() {
      if (this.newListCreation) {
        // Validate that the required field are filled before creating record
        this.$validator.validateAll('formListDetails').then(result => {
          if (result) {
            this.createRecordList();
            this.newListCreation = !this.newListCreation;
          } else {
            this.listErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else if (!this.editingDisabled) {
        // Validate that the required field are filled before updating record
        this.$validator.validateAll('formListDetails').then(result => {
          if (result) {
            this.updateRecordList();
            this.editingDisabled = !this.editingDisabled;
          } else {
            this.listErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else {
        this.editingDisabled = !this.editingDisabled;
      }
    },
    deleteButtonClicked() {
      this.showSwal('warning-message-and-confirmation');
    },
    cancelButtonClicked() {
      if (this.newListCreation) {
        this.$router.push({ name: 'CustomLists' });
      } else {
        this.editingDisabled = true;
        this.fetch();
      }
    },
    closeModalClipboard() {
      this.listErrorMessage = '';
      this.emailsToCopy = '';
      this.modals.clipboard = false;
    },
    copyEmailsToClipboard() {
      const dummyTextToCopy = document.createElement('input');
      document.body.appendChild(dummyTextToCopy);
      dummyTextToCopy.setAttribute('value', this.emailsToCopy);
      dummyTextToCopy.select();
      const successful = document.execCommand('copy');

      if (successful) {
        this.showSwal('basic-email-copy-success');
      } else {
        this.showSwal('basic-email-copy-failure');
      }
      document.body.removeChild(dummyTextToCopy);
      this.closeModalClipboard();
    },
    exportEmailsToTxtButtonClicked() {
      const url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/txt/private/customlists/${this.customListId}/emailslist`;

      this.$http
        .get(url, {
          headers: {
            Accept: 'text/plain',
          },
        })
        .then(response => {
          this.emailsToCopy = response.data;
          this.modals.clipboard = true;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    exportToCsvIEButtonClicked(windowsPlatform) {
      const url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/csv/private/customlists/${this.customList.id}?isWindowsPlatform=${windowsPlatform}`;

      this.$http
        .get(url, {
          headers: {
            Accept: 'text/csv',
          },
        })
        .then(response => {
          const BOM = '\uFEFF';
          const blobObject = new Blob([BOM + response.data]);

          window.navigator.msSaveBlob(
            blobObject,
            `liste_${this.customList.name ? this.customList.name : ''}.csv`,
          );
          // Or msSaveOrOpenBlob
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    exportToCsvOtherButtonClicked(windowsPlatform) {
      const url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/csv/private/customlists/${this.customList.id}?isWindowsPlatform=${windowsPlatform}`;

      this.$http
        .get(url, {
          headers: {
            Accept: 'text/csv',
          },
        })
        .then(response => {
          const BOM = '\uFEFF';
          const linkUrl = window.URL.createObjectURL(
            new Blob([BOM + response.data]),
          );
          const link = document.createElement('a');
          link.href = linkUrl;
          link.setAttribute(
            'download',
            `liste_${this.customList.name ? this.customList.name : ''}.csv`,
          ); // or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecordList() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/newlist`,
          {
            name: this.customList.name,
          },
        )
        .then(response => {
          this.customListId = response.data;
          this.listErrorMessage = '';
          this.$router.push({
            name: 'CustomListDetails',
            params: { id: this.customListId, newListCreation: false },
          });
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecordList() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/update/${this.customListId}`,
          {
            name: this.customList.name,
          },
        )
        .then(response => {
          this.listErrorMessage = '';
          this.fetch();
          this.getPeopleList();
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    deleteRecordList() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/customLists/delete/${this.customListId}`,
        )
        .then(response => {
          this.listErrorMessage = '';
          this.$router.push({
            name: 'CustomLists',
          });
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
  },
};
</script>

<style>
.list-error-message {
  margin-top: 10px;
  margin-left: 200px;
  padding-top: 10px;
  color: darkred;
}

.small-button {
  height: 1rem !important;
  min-width: 0.8rem !important;
  width: 1rem !important;
  line-height: initial !important;
}

.small-list-element {
  height: 1.5em !important;
}
.scrollable {
  overflow: auto;
  height: 300px;
}

.export-dropdown {
  position: absolute;
  right: 20px;
}

#select-address-type {
  padding-left: 15px;
  margin-top: -22px;
}

#btn-export {
  position: absolute;
  right: 10px;
  top: 10px;
  margin: 0px;
}

#btn-export-emails {
  position: absolute;
  right: 160px;
  top: 10px;
  margin: 0px;
}

.top-buttons-list {
  min-height: 60px;
}
</style>

<style scoped></style>
